// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Link } from '@iheartjane/reefer';

export const LinkStyled = styled(Link)({
  display: 'block',
  textDecoration: 'none',

  '[role=img], .brandCard_partnerLogo': {
    position: 'relative',
  },

  'a:focus-visible': {
    outline: 'none',
    '[role=img]:before, .brandCard_partnerLogo:before': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      borderRadius: 'inherit',
      content: '""',
      height: '100%',
      position: 'absolute',
      width: '100%',
    },
  },
});
